export const WCC_AMOUNT_FORMAT_ERROR = 'Введите сумму без пробелов, с точкой и не более чем двумя знаками после неё. Например: 1850 или 1850.50';

export function isValidWccAmount(value: string | number): boolean {
  const text = String(value);
  return !/\s/.test(text) && /^[0-9]+(?:\.[0-9]{1,2})?$/.test(text) && Number.isFinite(Number(value));
}
